import styled from 'styled-components';
import { Breakpoints } from '../../styled/constants';

export const GoogleMapContainer = styled.div`
  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    position: relative;
    overflow: hidden;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    margin: 0 20px;
    border-radius: 5px;
    overflow: hidden;
  }
`;
